import { useLoaderData } from "react-router-dom";
import { useState } from "react";
import { getCollectionDetails } from "../../api/Get";
import { message, Typography } from "antd";
import FormColletion from "./FormCollection";
import { putCollection } from "../../api/Update";

const { Title } = Typography;

const putCollectionLoader = async ({ params }) => {
  const details = await getCollectionDetails(params.uidCollection);
  return details;
};

const PutCollection = () => {
  // const navigate = useNavigate();
  const { collection, pubHouse } = useLoaderData();

  const [messageApi, contextHolder] = message.useMessage();

  const [errorMsg, setErrorMsg] = useState("");

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Collection mise à jour",
    });
  };

  const onFinish = async (values) => {
    if (collection.uid) {
      const res = await putCollection(collection.uid, { ...values });
      if (res.error) setErrorMsg(res.error);
      else success();
    }
  };

  return (
    <>
      {contextHolder}
      <Title level={2}>Mettre à jour une collection</Title>
      <FormColletion
        initialValues={{
          collectionState: collection.statut,
          pubHouseName: collection.PublishingHouseName,
          collectionName: collection.name,
          uidCollection: collection.uid,
        }}
        collection={collection}
        onFinish={onFinish}
        errorMsg={errorMsg}
        pubHouse={pubHouse}
        type={"update"}
      />
    </>
  );
};

export { PutCollection, putCollectionLoader };
